import { SxProps, Theme } from "@mui/material";

export const availabilityCheckoutStyles = {
  container: () => ({
    maxWidth: "680px",
    margin: "0 auto",
  }),
  header: {
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    padding: "14px 16px",
    position: "relative",
  },
  businessName: (showBack: string | null) => ({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    borderBottom: "1px solid #D6D6DA",
    width: "fit-content",
    cursor: "pointer",
    // width: showBack ? "90%" : "fit-content",
  }),
  businessText: (theme: Theme, showBack: string | null) => ({
    fontSize: 22,
    fontWeight: 600,
    fontFamily: theme.typography.fontFamily,
    color: "#000",
    width: "fit-content",
  }),
  viewMoreText: (theme: Theme) => ({
    fontSize: 11,
    fontWeight: 400,
    color: "#8D8D8D",
    cursor: "pointer",
    marginTop: "0px",
    fontFamily: theme.typography.fontFamily,
  }),
  carouselImageContainer: {
    position: "relative",
    width: "100%",
    height: "240px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderTopLeftRadius: "20px",
    borderTopRightRadius: "20px",
  },
  carouselImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    borderRadius: "inherit",
  },
  locationTag: (theme: Theme): SxProps<Theme> => ({
    position: "absolute",
    bottom: "30px",
    right: "10px",
    backgroundColor: "#328734",
    color: "#fff",
    padding: "4px 10px",
    borderRadius: "12px",
    display: "flex",
    alignItems: "center",
    fontSize: "11px",
    fontWeight: "700",
    fontFamily: theme.typography.fontFamily,
  }),
  locationImage: {
    width: "12px",
    height: "14px",
    marginRight: "6px",
  },
  detailsContainer: {
    maxWidth: "680px",
  },
  detailsInnerBox: {
    mx: 1.5,
    display: "flex",
    flexDirection: "column",
    gap: 0.5,
  },
  title: (theme: Theme): SxProps<Theme> => ({
    fontSize: 24,
    mt: 1.5,
    textAlign: "center",
    fontWeight: 700,
    color: "#0D0D0D",
    fontFamily: theme.typography.fontFamily,
    lineHeight: "34px",
    letterSpacing: "0.089px",
  }),
  subtitle: (theme: Theme): SxProps<Theme> => ({
    fontSize: 13,
    textAlign: "center",
    fontWeight: 400,
    color: "#0D0D0D",
    marginTop: "-7px",
    fontFamily: theme.typography.fontFamily,
  }),
  infoContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    gap: 4,
    marginBottom: 1,
  },
  infoItem: {
    display: "flex",
    alignItems: "center",
    gap: 1,
  },
  itemText: (theme: Theme): SxProps<Theme> => ({
    fontSize: 15,
    fontWeight: 400,
    color: "#0D0D0D",
    fontFamily: theme.typography.fontFamily,
  }),
  divider: {
    borderBottom: "1px solid #D6D6DA",
  },
  seeMoreText: (theme: Theme): SxProps<Theme> => ({
    fontWeight: 600,
    fontSize: 15,
    color: "black",
    textAlign: "right",
    fontFamily: theme.typography.fontFamily,
    textDecoration: "underline",
    marginTop: 0,
  }),
  iconText: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "8px",
  },
  bookingDetailsContainer: {
    display: "flex",
    flexDirection: "column",
    marginTop: "20px",
    gap: "10px",
  },
  bookingDetailsText: {
    fontSize: "24px",
    fontWeight: "700",
  },
  bookingDetailTypography: {
    fontSize: "17px",
    fontWeight: 400,
  },
  calendarIcon: {
    width: "16px",
    height: "16px",
  },
  clockIcon: {
    width: "16px",
    height: "16px",
  },
  dateAndTimeContainer: {
    mt: 2,
    backgroundColor: "#E8E8EB",
    boxShadow: "0px 0px 4px 0px rgba(0, 0, 0, 0.25)",
    borderRadius: "12px",
    padding: "16px",
  },
  promotionalContainer: {
    backgroundColor: "#FFF",
    color: "#000",
    textAlign: "left",
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    mt: 6,
    mb: 2,
    gap: 1
  },
  promotionalIconContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flex: 0.1
  },
  promotionalTextContainer: {
    display: "flex",
    flexDirection: "column",
    textAlign: "center",
    alignItems: "center",
    justifyContent: "center",
    flex: 0.7,

  },
  promoTitle: (theme: Theme): SxProps<Theme> => ({
    fontWeight: 500,
    fontSize: 20,
    color: "#000",
    width: "fit-content",
    fontFamily: theme.typography.fontFamily,
  }),
  promoSubtitle: (theme: Theme): SxProps<Theme> => ({
    fontSize: 15,
    fontFamily: theme.typography.fontFamily,
    // width: "230px",
    lineHeight: "18.5px",
    letterSpacing: "0.27px",
    fontWeight: 400,
    color: "#000",
  }),

  cancellationPolicyContainer: {
    backgroundColor: "#595959",
    borderRadius: "8px",
    display: "flex",
    flexDirection: "column",
    mt: 3,
    mb: 1,
    padding: "12px 16px",
  },
  cancellationHeader: {
    display: "flex",
    flexDirection: "row",
  },
  cancellationIcon: {
    marginRight: "8px",
    width: "28px",
    height: "28px",
  },
  cancellationPolicyTitle: (theme: Theme) => ({
    fontSize: "22px",
    fontFamily: theme.typography.fontFamily,
    fontWeight: 600,
    color: "#FFF",
  }),
  cancellationPolicyText: (theme: Theme) => ({
    fontSize: "15px",
    fontFamily: theme.typography.fontFamily,
    fontWeight: 400,
    color: "#FFF",
  }),
  cancellationPolicyToggle: {
    fontSize: "15px",
    fontWeight: 600,
    color: "#FFF",
    cursor: "pointer",
    textAlign: "right",
    textDecoration: "underline",
  },
  bookNowButton: {
    borderRadius: "8px",
    padding: "12px 24px",
    backgroundColor: "#328734",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
  },

  fireIcon: {
    marginRight: "8px",
    width: 13,
    height: 17,
  },
  bookNowText: {
    color: "#fff",
    fontSize: 17,
    fontWeight: 600,
  },

  priceContainer: {
    display: "flex",
    flexDirection: "column",
  },
  priceValue: (theme: Theme): SxProps<Theme> => ({
    fontSize: 22,
    fontWeight: 600,
    fontFamily: theme.typography.fontFamily,
  }),
  priceFee: (theme: Theme): SxProps<Theme> => ({
    fontSize: 13,
    fontWeight: 400,
    fontFamily: theme.typography.fontFamily,
    color: "#0D0D0D",
  }),

  redFireIcon: {
    marginTop: "5px",
  },
  userAvatar: {
    width: "34px",
    height: "34px",
    objectFit: "fill",
    borderRadius: "20px",
  },
  userNameText: (theme: Theme): SxProps<Theme> => ({
    fontWeight: 400,
    fontSize: 17,
    mb: 0.5,
    fontFamily: theme.typography.fontFamily,
  }),
  referredByContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "end",
    gap: 1.5,
  },
  referredByText: (theme: Theme): SxProps<Theme> => ({
    fontWeight: 600,
    fontSize: 22,
    mb: 1,
    mt: 2,
    fontFamily: theme.typography.fontFamily,
  }),
  poweredByContainer: {
    my: 2,
  },
  poweredByText: {
    textAlign: "center",
    fontSize: "13px",
    fontWeight: 400,
    color: "#000",
    lineHeight: "18.5px",
    letterSpacing: "0.203px",
  },
  logoImageContainer: {
    display: "flex",
    justifyContent: "center",
  },
  logoImage: {
    marginLeft: "auto",
    marginRight: "auto",
    width: "80px",
    height: "17px",
  },
  footer: {
    position: "sticky",
    width: "100%",
    mx: "auto",
    pb: "24px",
    bottom: 0,
    pt: "24px",
    borderTop: 0.5,
    borderColor: "#8D8D8D",
    backgroundColor: "#fff",
  },
  footerInner: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "0 10px",
  },
  priceSection: {
    display: "flex",
    flexDirection: "column",
  },
};
